import axios from 'axios';
import {backendHost} from '../../../../store/config';

const updatePaymentSystem = (params) => {
    return axios.post(`${backendHost}/api/admin/payment/update`, params);
};

export {
    updatePaymentSystem
}